// pages/messages/CompanyJobMessagesList.js
import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import api from '../../services/api'
import { useGlobal } from '../../context/GlobalContext'
import '../../assets/css/messages.css'

function CompanyJobMessagesList() {
  const { jobId } = useParams()
  const { showLoading, hideLoading, showMessage } = useGlobal()
  const [messages, setMessages] = useState([])
  const [newMessage, setNewMessage] = useState('')

  useEffect(() => {
    loadMessages()
  }, [jobId])

  async function loadMessages() {
    try {
      showLoading()
      const res = await api.get(`/company-messages/job/${jobId}`)
      setMessages(res.data.messages)
      hideLoading()
    } catch (err) {
      hideLoading()
      showMessage(err.response?.data?.error || 'Error loading messages', 'error')
    }
  }

  async function sendMessage() {
    if (!newMessage.trim()) return
    try {
      showLoading()
      await api.post(`/company-messages/job/${jobId}/whatsapp`, { text: newMessage })
      setNewMessage('')
      loadMessages()
      hideLoading()
      showMessage('Message sent', 'success')
    } catch (err) {
      hideLoading()
      showMessage(err.response?.data?.error || 'Error sending message', 'error')
    }
  }

  function formatDateTime(dt) {
    return new Date(dt).toLocaleString()
  }

  return (
    <div className="chat-container page-container">
      <h2>Chat</h2>
      <div className="chat-messages">
        {messages.map(msg => (
          <div
            key={msg._id}
            className={
              msg.senderType === 'trucker'
                ? 'chat-message trucker'
                : msg.senderType === 'user'
                ? 'chat-message user'
                : 'chat-message system'
            }
          >
            <div className="sender-name">{msg.senderName}</div>
            <div className="message-text">{msg.text}</div>
            <div className="timestamp">{formatDateTime(msg.createdAt)}</div>
          </div>
        ))}
      </div>
      <div className="chat-input-container">
        <input
          type="text"
          placeholder="Type a message"
          value={newMessage}
          onChange={e => setNewMessage(e.target.value)}
        />
        <button className="btn" onClick={sendMessage}>Send</button>
      </div>
    </div>
  )
}

export default CompanyJobMessagesList